import { postEmpty } from "./common";

export const debugTools = {
    resetDatabase() {
        return postEmpty("/debug-tools/database/reset");
    },
};
